import { Alert, Transfer, message } from "antd";
import React, { useEffect, useState } from "react";
import StrapiServices from "../../StrapiServices";
import _ from "lodash";
import Company from "../../services/CompanyServices";
import { translate } from "../../locale";

const TransferCategoriesStrapiCapsule = ({
  selectedCategories,
  subscriptionId,
  enterpriseId,
}) => {
  const [targetKeys, setTargetKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    getCategories();
  }, [selectedCategories]);

  const getCategories = async () => {
    setLoading(true);
    try {
      const response = await StrapiServices.getCategories();
      if (response.status >= 200 && response.status < 300) {
        const target = _.flatMap(
          _.intersectionBy(response.data, selectedCategories, "id"),
          "id"
        );

        setTargetKeys(target);
        setData(
          response.data.map((v, i) => ({
            key: v.id,
            ...v,
          }))
        );
      }
    } catch (error) {
      console.log("getCategories error:", error);
    } finally {
      setLoading(false);
    }
  };

  const onChange = (nextTargetKeys, direction, moveKeys) => {
    updateCategories(nextTargetKeys);
    setTargetKeys(nextTargetKeys);
  };

  const onSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
  };

  const updateCategories = async (targetKeys) => {
    try {
      const values = {
        subscription_id: subscriptionId,
        enterprise_id: enterpriseId,
        categories: targetKeys,
      };

      const response = await Company.updateSubscriptionCategories(values);
      if (response.status >= 200 && response.status < 300) {
        message.success(
          translate(
            "Las {0} se guardaron exitosamente.",
            translate("categorias")
          )
        );
      } else if (response.data.message) {
        message.error(response.data.message);
      } else {
        message.error(response.statusText);
      }
    } catch (error) {
      console.log("updateCategories error: ", error);
      setError(error.message);
    }
  };

  return (
    <>
      <Transfer
        dataSource={data}
        titles={[
          selectedKeys.length === 1
            ? translate("No asociada")
            : translate("No asociadas"),
          targetKeys.length === 1
            ? translate("Asociada")
            : translate("Asociadas"),
        ]}
        locale={{
          itemUnit: translate("categoría"),
          itemsUnit: translate("categorías"),
          searchPlaceholder: translate("Buscar"),
          notFoundContent: (
            <div className="p-6">{translate("No encontramos categorías.")}</div>
          ),
        }}
        targetKeys={targetKeys}
        selectedKeys={selectedKeys}
        onChange={onChange}
        onSelectChange={onSelectChange}
        render={(item) => item.name}
        listStyle={{ width: 300 }}
        loading={loading}
      />

      {error && (
        <Alert
          message={error}
          type="error"
          className="mb-6"
          closable
          onClose={() => setError("")}
        />
      )}
    </>
  );
};
export default TransferCategoriesStrapiCapsule;
